import { atom } from "recoil"
import { DataSource } from "../Types/DataSource"
import { PersystMontageDefinition } from "../Types/PersystWindow"
import { DataReviewSource } from "../Types/AssociatedDataSources"

type PersystRecordingInfo = {
    recordingStartDate: Date
    recordingEndDate: Date
}

type PatientFileInfo = {
    fileStartDate: Date
    fileEndDate: Date
    patientId: string // id field in db-patient
    patientIdentifier: string // patient_id field in db-patient
    dataSourceMap: Map<DataSource, number>
    sources: Map<DataSource, DataReviewSource>
    sourceModalities: Map<DataSource, string[]>
    patientModalities: string[],
    timeZone: string
    montageMapping: Map<string, string> // If the patient has EEG, the mapping of physical inputs on the EEG amp to their labels.
    isAdmitted: boolean
    persystRecordingInfo: PersystRecordingInfo | null
    persystMontageDefinitions: PersystMontageDefinition[]
    gatewayId: number | undefined
    mrnError: string | undefined
}

export const currentPatientFileInfoAtom = atom<PatientFileInfo>({
    key: "currentPatientFileInfo",
    default: {
        fileStartDate: new Date(0), // file times are local to the time zone of the patient file, NOT UTC
		fileEndDate: new Date(0),
        patientId: "?",
        patientIdentifier: "?",
        dataSourceMap: new Map(),
        sources: new Map(),
        sourceModalities: new Map(),
        patientModalities: [],
        montageMapping: new Map(),
        isAdmitted: true,
        timeZone: "America/New_York",
        persystRecordingInfo: null,
        persystMontageDefinitions: [],
        gatewayId: undefined,
        mrnError: undefined
    }
})

export const livePatientFileEndTimeAtom = atom<any>({
    key: "livePatientFileEndTime",
    default: new Date(0)
})
